import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/admin/AuthContext";

/**
 * StaffProtectedRoute — same JWT auth as admin, but redirects to /staff/login
 * (not /admin/login) so the admin entrypoint stays hidden.
 */
export default function StaffProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="staff-shell min-h-screen flex items-center justify-center">
        <p className="font-mono-pl text-[10px] uppercase tracking-[0.32em] text-[#B6B6BE]">
          Connessione al terminale…
        </p>
      </div>
    );
  }

  if (!user || !user.email) {
    return <Navigate to="/staff/login" state={{ from: location }} replace />;
  }

  return children;
}
